import { hasGpcSignal, type ConsentChoice } from "@/consent/consent";

export type ConsentMetricAction = "accepted" | "customized" | "dismissed";

// keepalive lets the request survive the reload that follows a revocation.
export function sendConsentMetric(
  action: ConsentMetricAction,
  choice: ConsentChoice,
): void {
  fetch("/api/consent-metric", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      action,
      analytics: choice.analytics,
      marketing: choice.marketing,
      hadGpc: hasGpcSignal(),
    }),
    keepalive: true,
  }).catch((error) => {
    console.error("Failed to send consent metric:", error);
  });
}
